/**
 * Promotion = current collection ∩ collection "promotions" (AJAX).
 * Also merges Dispo / Précommande / Promo so they can stack without wiping each other.
 */
(function ($) {
  var promoIdsCache = null;
  var busy = false;
  var ignoreListingEvent = false;

  function $root() {
    return $('.lmz-promo-filter').first();
  }

  function collectionBaseUrl() {
    var u = $root().attr('data-collection-url');
    return (u || window.location.pathname || '').replace(/\/+$/, '');
  }

  /** Handle of the current collection (ignores tag path segments). */
  function currentCollectionHandle() {
    var path = (window.location.pathname || collectionBaseUrl() || '').replace(/\/+$/, '');
    var m = path.match(/\/collections\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function promoHandle() {
    return $root().attr('data-promo-handle') || 'promotions';
  }

  function pageSize() {
    var n = parseInt($root().attr('data-page-size'), 10);
    return n > 0 ? n : 24;
  }

  function productsCount() {
    var n = parseInt($root().attr('data-products-count'), 10);
    return n > 0 ? n : 0;
  }

  function hasPromoParam(search) {
    return /(?:^|[?&])lmz_promo=1(?:&|$)/.test(search == null ? window.location.search || '' : search);
  }

  function stripParams(url, keys) {
    var parts = String(url || '').split('?');
    var path = parts[0];
    if (parts.length < 2) return path;
    var kept = parts[1].split('&').filter(function (pair) {
      var k = pair.split('=')[0];
      return keys.indexOf(k) === -1 && pair !== '';
    });
    return kept.length ? path + '?' + kept.join('&') : path;
  }

  function stripPromo(url) {
    return stripParams(url, ['lmz_promo', 'view', 'page']).replace(/[?&]$/, '').replace(/\?&/, '?');
  }

  function withAjaxView(url) {
    var u = stripParams(url, ['view']);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'view=ajax';
  }

  /** Current listing URL without lmz_promo / view / page (keeps tags path + dispo filters). */
  function currentFilteredUrl() {
    var path = window.location.pathname || collectionBaseUrl();
    var qs = stripParams(window.location.search || '', ['lmz_promo', 'view', 'page']).replace(/^\?/, '');
    return qs ? path + '?' + qs : path;
  }

  function publicUrl(on) {
    var base = currentFilteredUrl();
    if (on) return base + (base.indexOf('?') > -1 ? '&' : '?') + 'lmz_promo=1';
    return base;
  }

  function setSwitchState(on) {
    var $wrap = $root();
    if (!$wrap.length) return;
    var $li = $wrap.find('li').first();
    var $a = $wrap.find('a.lmz-switch-row').first();
    var $sw = $wrap.find('.lmz-switch').first();
    if (on) {
      $li.addClass('active');
      $sw.addClass('is-on');
      $a.attr('aria-pressed', 'true').attr('href', publicUrl(false));
    } else {
      $li.removeClass('active');
      $sw.removeClass('is-on');
      $a.attr('aria-pressed', 'false').attr('href', publicUrl(true));
    }
  }

  function pushUrl(url) {
    if (window.history && window.history.pushState) {
      window.history.pushState({ lmzPromo: true }, document.title, url);
    }
  }

  function showLoader(show) {
    var $loader = $('.custom-loader');
    if (show) $loader.show();
    else $loader.hide();
  }

  function refreshUi() {
    ignoreListingEvent = true;
    $('body').trigger('refreshCurrency');
    $('body').trigger('listingpageajax');
    if (typeof ttProductSmall === 'function') ttProductSmall();
    if (typeof countDown === 'function') countDown(true);
    if (typeof initImagesSize === 'function') initImagesSize();
    if (typeof lazyload === 'function') lazyload();
    if (window.wl_handler && typeof wl_handler.selectItems === 'function') wl_handler.selectItems();
    if (window.compare && typeof compare.selectItems === 'function') compare.selectItems();
    setTimeout(function () {
      ignoreListingEvent = false;
    }, 0);
  }

  /**
   * Theme-like AJAX reload of listing + sidebar filter widgets.
   * Keeps promo switch (not shopifyfiltres) intact; updates shopifyfiltres blocks.
   */
  function themeLikeAjax(url, done) {
    showLoader(true);
    $.ajax({
      type: 'GET',
      url: withAjaxView(url),
      dataType: 'html'
    })
      .done(function (data) {
        var $html = $('<div>').append($.parseHTML(data));

        var $newListing = $html.find('.tt-product-listing').first();
        if ($newListing.length) {
          $('.tt-product-listing').first().html($newListing.html());
        }

        var oldFilters = $('.shopifyfiltres-js').toArray();
        oldFilters.forEach(function (el, index) {
          var $old = $(el);
          if (!$old.parent().length) return;
          var $parent = $old.closest('.tt-collapse');
          var $neu = $html.find('.shopifyfiltres-js').eq(index);
          if ($neu.length) {
            var hide = $neu.closest('.tt-collapse').hasClass('hide');
            $old.replaceWith($neu.clone());
            if (hide) $parent.addClass('hide');
            else $parent.removeClass('hide');
          }
        });

        var $newTotal = $html.find('.listing-total-js').first();
        if ($newTotal.length && $('.listing-total-js').length) {
          $('.listing-total-js').replaceWith($newTotal);
        }

        var $newPager = $html.find('.tt_product_showmore.infinitybutton').first();
        if ($newPager.length && $('.tt_product_showmore.infinitybutton').length) {
          $('.tt_product_showmore.infinitybutton').first().replaceWith($newPager);
        }

        pushUrl(stripParams(url, ['view']));
        refreshUi();
        if (typeof done === 'function') done(data);
        else showLoader(false);
      })
      .fail(function () {
        showLoader(false);
      });
  }

  function fetchJsonIds(handle) {
    var ids = {};
    var page = 1;
    var deferred = $.Deferred();

    function load() {
      $.ajax({
        url: '/collections/' + handle + '/products.json',
        data: { limit: 250, page: page },
        dataType: 'json'
      })
        .done(function (res) {
          var products = (res && res.products) || [];
          for (var i = 0; i < products.length; i++) {
            ids[String(products[i].id)] = true;
          }
          if (products.length >= 250 && page < 40) {
            page += 1;
            load();
          } else {
            deferred.resolve(ids);
          }
        })
        .fail(function () {
          deferred.resolve(ids);
        });
    }
    load();
    return deferred.promise();
  }

  function getPromoIds() {
    if (promoIdsCache) {
      return $.Deferred().resolve(promoIdsCache).promise();
    }
    return fetchJsonIds(promoHandle()).then(function (ids) {
      promoIdsCache = ids;
      return ids;
    });
  }

  function itemProductId($item) {
    var id = $item.find('[data-productid]').first().attr('data-productid');
    return id ? String(id) : '';
  }

  function parseListingItems(html) {
    return $('<div>').append($.parseHTML(html)).find('.tt-product-listing .tt-col-item');
  }

  function renderItems($items) {
    var $listing = $('.tt-product-listing').first();
    $listing.empty().removeClass('flex-center-message');
    if (!$items || !$items.length) {
      $listing.addClass('flex-center-message').append(
        '<div class="tt-empty-search">' +
          '<span class="tt-icon icon-g-84"></span>' +
          '<p class="tt-title">Aucun produit</p>' +
          '</div>'
      );
      return;
    }
    $listing.append($items);
  }

  function updateTotalCount(count) {
    var $total = $('.listing-total-js');
    if (!$total.length) return;
    var text = $total.text();
    var m = text.match(/^(.*?:)\s*\d[\d\s.,]*$/);
    if (m) $total.text(m[1] + ' ' + count);
    else $total.text(text.replace(/\d[\d\s.,]*$/, String(count)));
  }

  function setPromoChrome(on, count) {
    var $pagerWrap = $('.tt_product_showmore.infinitybutton, .product-pagintion').first();
    var $pagination = $('.tt-pagination');
    if (on) {
      updateTotalCount(count);
      $pagination.hide();
      $pagerWrap.addClass('hide');
    } else {
      $pagination.show();
      $pagerWrap.removeClass('hide');
    }
  }

  function restoreChromeFromHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));
    var $newTotal = $html.find('.listing-total-js').first();
    if ($newTotal.length && $('.listing-total-js').length) {
      $('.listing-total-js').replaceWith($newTotal);
    }
    var $newPager = $html.find('.tt_product_showmore.infinitybutton').first();
    if ($newPager.length && $('.tt_product_showmore.infinitybutton').length) {
      $('.tt_product_showmore.infinitybutton').first().replaceWith($newPager);
    } else {
      var $newPag = $html.find('.tt-pagination').first();
      if ($newPag.length && $('.tt-pagination').length) {
        $('.tt-pagination').first().replaceWith($newPag);
      }
    }
    setPromoChrome(false, 0);
  }

  function pageCountFor() {
    var $total = $('.listing-total-js').first();
    var fromUi = 0;
    if ($total.length) {
      var m = $total.text().match(/(\d[\d\s.,]*)\s*$/);
      if (m) fromUi = parseInt(String(m[1]).replace(/[^\d]/g, ''), 10) || 0;
    }
    var count = fromUi || productsCount();
    var size = pageSize();
    if (!count) return 1;
    return Math.max(1, Math.ceil(count / size));
  }

  function intersectIds(a, b) {
    var out = {};
    Object.keys(a).forEach(function (id) {
      if (b[id]) out[id] = true;
    });
    return out;
  }

  /**
   * Load listing HTML pages until every matched product card is found
   * (or all pages are scanned). Batches of parallel requests.
   */
  function fetchMatchedCards(filteredUrl, matchIds) {
    var deferred = $.Deferred();
    var need = Object.keys(matchIds).length;
    var kept = [];
    var seen = {};
    var base = stripParams(filteredUrl, ['page', 'view', 'lmz_promo']);
    var totalPages = pageCountFor();
    var page = 1;
    var batchSize = 8;

    if (need === 0) {
      deferred.resolve($());
      return deferred.promise();
    }

    function absorb(html) {
      parseListingItems(html).each(function () {
        var id = itemProductId($(this));
        if (id && matchIds[id] && !seen[id]) {
          seen[id] = true;
          kept.push(this);
        }
      });
    }

    function nextBatch() {
      if (Object.keys(seen).length >= need || page > totalPages) {
        deferred.resolve($(kept));
        return;
      }

      var reqs = [];
      var end = Math.min(page + batchSize - 1, totalPages);
      for (var p = page; p <= end; p++) {
        var u = base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + p;
        reqs.push(
          $.ajax({
            type: 'GET',
            url: withAjaxView(u),
            dataType: 'html'
          })
        );
      }
      page = end + 1;

      $.when
        .apply($, reqs)
        .done(function () {
          var args = arguments;
          if (reqs.length === 1) absorb(args[0]);
          else {
            for (var i = 0; i < args.length; i++) absorb(args[i][0]);
          }
          nextBatch();
        })
        .fail(function () {
          deferred.resolve($(kept));
        });
    }

    nextBatch();
    return deferred.promise();
  }

  function applyPromoOn() {
    if (busy) return;
    busy = true;
    showLoader(true);

    var filtered = currentFilteredUrl();
    var handle = currentCollectionHandle();

    // 1) Exact intersection via products.json (complete, not limited by HTML page cap)
    // 2) Then pull matching cards from listing HTML until all IDs are found
    $.when(getPromoIds(), fetchJsonIds(handle))
      .then(function (promoIds, currentIds) {
        // $.when with promises may nest arrays depending on jQuery version
        if ($.isArray(promoIds)) promoIds = promoIds[0];
        if ($.isArray(currentIds)) currentIds = currentIds[0];
        var matchIds = intersectIds(currentIds || {}, promoIds || {});
        return fetchMatchedCards(filtered, matchIds);
      })
      .done(function ($items) {
        renderItems($items);
        setPromoChrome(true, $items.length);
        setSwitchState(true);
        pushUrl(publicUrl(true));
        refreshUi();
      })
      .always(function () {
        showLoader(false);
        busy = false;
      });
  }

  function applyPromoOff() {
    if (busy) return;
    busy = true;
    showLoader(true);

    var url = currentFilteredUrl();
    $.ajax({
      type: 'GET',
      url: withAjaxView(url),
      dataType: 'html'
    })
      .done(function (html) {
        renderItems(parseListingItems(html));
        restoreChromeFromHtml(html);
        setSwitchState(false);
        pushUrl(publicUrl(false));
        refreshUi();
      })
      .always(function () {
        showLoader(false);
        busy = false;
      });
  }

  /**
   * Merge Dispo / Préco href with current URL so filters stack.
   * - Précommande changes pathname (tags) → keep current query (availability, sort…)
   * - Disponible changes query → keep current pathname (tags) + target availability params
   * - Always keep lmz_promo if currently on
   */
  function mergeQuickFilterHref(href, $link) {
    var a = document.createElement('a');
    a.href = href;

    var label = ($link.closest('.lmz-switch-filter').find('.lmz-switch-label').text() || '').toLowerCase();
    var isDispo = label.indexOf('disponible') !== -1;
    var promoOn = hasPromoParam();

    var path;
    var params = {};

    function parseSearch(search) {
      var out = {};
      String(search || '')
        .replace(/^\?/, '')
        .split('&')
        .forEach(function (pair) {
          if (!pair) return;
          var kv = pair.split('=');
          var k = decodeURIComponent(kv[0] || '');
          if (!k || k === 'view' || k === 'page' || k === 'lmz_promo') return;
          out[k] = kv.length > 1 ? kv.slice(1).join('=') : '';
        });
      return out;
    }

    function toSearch(obj) {
      var parts = [];
      Object.keys(obj).forEach(function (k) {
        parts.push(encodeURIComponent(k) + '=' + obj[k]);
      });
      return parts.length ? '?' + parts.join('&') : '';
    }

    var curParams = parseSearch(window.location.search);
    var tgtParams = parseSearch(a.search);

    if (isDispo) {
      // Keep tagged path; availability comes from target href
      path = window.location.pathname;
      params = $.extend({}, curParams);
      // Remove old availability keys then apply target's
      Object.keys(params).forEach(function (k) {
        if (k.indexOf('filter.v.availability') === 0) delete params[k];
      });
      Object.keys(tgtParams).forEach(function (k) {
        if (k.indexOf('filter.v.availability') === 0) params[k] = tgtParams[k];
        else if (!(k in params)) params[k] = tgtParams[k];
      });
      // If target had no availability key, we intentionally removed it (switch OFF)
    } else {
      // Précommande (or other tag switch): new path, keep current filters query
      path = a.pathname;
      params = $.extend({}, curParams);
      Object.keys(tgtParams).forEach(function (k) {
        params[k] = tgtParams[k];
      });
    }

    var url = path + toSearch(params);
    if (promoOn) url += (url.indexOf('?') > -1 ? '&' : '?') + 'lmz_promo=1';
    return url;
  }

  // Capture-phase: intercept Dispo / Préco before theme shopifyfiltres handler
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('.lmz-quick-filters .shopifyfiltres-js a.lmz-switch-row');
      if (!a) return;
      if (a.getAttribute('data-lmz-promo-toggle')) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var $a = $(a);
      var merged = mergeQuickFilterHref(a.getAttribute('href'), $a);
      var promoOn = /lmz_promo=1/.test(merged);

      busy = true;
      themeLikeAjax(stripParams(merged, ['lmz_promo']), function () {
        pushUrl(merged);
        setSwitchState(promoOn);
        busy = false;
        if (promoOn) {
          applyPromoOn();
        } else {
          showLoader(false);
        }
      });
    },
    true
  );

  $(document).on('click', '.tt-pagination a, .tt_product_showmore a', function (e) {
    if (!hasPromoParam()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  });

  $(document).on('click', '.lmz-promo-filter a[data-lmz-promo-toggle]', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (hasPromoParam()) applyPromoOff();
    else applyPromoOn();
  });

  $(document).ready(function () {
    if (!$root().length) return;
    getPromoIds();
    if (hasPromoParam()) applyPromoOn();
  });
})(jQuery);
